<div mat-dialog-title>{{ data.title }}</div>
<mat-dialog-content>
  <p [innerHTML]="data.content"></p>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <ng-container *ngIf="data.cancel">
    <button mat-button (click)="onNoClick()" [innerHTML]="data.cancel"></button>
  </ng-container>
  <ng-container *ngIf="data.confirm">
    <button
      mat-raised-button
      (click)="confirm(data)"
      color="primary"
      [innerHTML]="data.confirm"
    ></button>
  </ng-container>
</mat-dialog-actions>
